// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Tooltip } from '@material-ui/core';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import School from 'material-ui/svg-icons/social/school';
import Receipt from 'material-ui/svg-icons/action/receipt';
import Radio from 'common/domain/radio';
import NotificationsPanel from 'common/modules/ui/components/NotificationsPanel';
import { Logo } from 'common/layout/styles';
import { Images } from '../../themes';
import ProfileDropDown from './ProfileDropDown';
import AuthorisedComponent from '../../modules/authorisation/AuthorisedComponent';
import Permissions from '../../modules/authorisation/Permissions';

const SAppBar = styled(AppBar)`
  box-shadow: none;
`;

const SToolbar = styled(Toolbar)`
  display: flex;
  min-height: ${props => props.theme.V3.metrics.navbar.height}px;
  height: ${props => props.theme.V3.metrics.navbar.height}px;
  background-color: ${props => props.theme.V3.colors.primary.normal};
  color: ${props => props.theme.V3.colors.text.tertiary};
`;

const SMenuIcon = styled(MenuIcon)`
  margin-right: 24px;
`;

const LogoContainer = styled.div`
  margin: 0;
`;

const SLogo = styled(Logo)`
  cursor: pointer;
  height: 25px;
  width: 110px;
  margin: auto;
`;

const Spacer = styled.div`
  flex: 1;
`;

const HelpersContainer = styled.div`
  display: flex;
  margin-right: 50px;
`;

const SLink = styled(Link)`
  height: ${props => props.theme.V3.metrics.icon.frameSize}px;
  width: ${props => props.theme.V3.metrics.icon.frameSize}px;
  padding: ${props => props.theme.V3.metrics.icon.framePadding}px;
`;


interface Props {
  forceMenuDisplay: boolean;
  switchRadio: (radio: Radio) => mixed;
  notificationRenderers: Object;
  onMenuIconClick: () => void;

  theme: any;
  t: any;
}

function NavBar({ forceMenuDisplay, switchRadio, notificationRenderers, onMenuIconClick, theme, t }: Props) {
  return (
    <SAppBar>
      <SToolbar theme={theme}>
        {!forceMenuDisplay &&
        <SMenuIcon onClick={onMenuIconClick} color={theme.V3.colors.text.tertiary} />
        }
        <LogoContainer>
          <Link to={'/'}>
            <SLogo src={Images.logoWhite} alt="logo" />
          </Link>
        </LogoContainer>

        <Spacer />

        <HelpersContainer>
          <NotificationsPanel switchRadio={switchRadio} notificationRenderers={notificationRenderers} />

          <Tooltip title={t('menu.tutorials')}>
            <SLink to={'/tutorials'}>
              <School color={theme.V3.colors.text.tertiary} />
            </SLink>
          </Tooltip>

          <AuthorisedComponent permissions={Permissions.BILL_RADIOS}>
            <Tooltip title={t('menu.invoicing')}>
              <SLink to={'/invoicing'}>
                <Receipt color={theme.V3.colors.text.tertiary} />
              </SLink>
            </Tooltip>
          </AuthorisedComponent>

        </HelpersContainer>

        <ProfileDropDown />
      </SToolbar>
    </SAppBar>
  );
}

export default translate()(withTheme(NavBar));



// WEBPACK FOOTER //
// ./src/statsradio/layout/v2/NavBar.js